import React from 'react';

/**
 * 로그인 후 기존 React 레이아웃(상단바/좌측메뉴) 안에 배치하는 사용자 가이드.
 * 로그인 판별은 기존 Spring Security/React 라우트가 담당합니다.
 * iframe 안에서는 정적 사이트 자체 헤더를 출력하지 않습니다.
 */
class InstagramHelpCenter extends React.Component {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
    this.handleResize = this.handleResize.bind(this);
    this.state = { frameHeight: 680 };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (!this.iframeRef.current) return;
    const rect = this.iframeRef.current.getBoundingClientRect();
    const available = window.innerHeight - rect.top - 18;
    const nextHeight = Math.max(480, Math.floor(available));
    if (this.state.frameHeight !== nextHeight) {
      this.setState({ frameHeight: nextHeight });
    }
  }

  render() {
    const guidePath = '/sns-auto/help-center/preview/index.html?embedded=1';
    const guideUrl = window.location.port === '3000'
      ? window.location.protocol + '//' + window.location.hostname + ':8092' + guidePath
      : guidePath;

    return (
      <>
        <style>{`
            #page-wrapper {
                padding: 70px 0 0 220px !important;
                max-width: 100%;
            }
            @media (max-width: 800px) {
                #page-wrapper {
                    padding: 60px 0 0 0 !important;
                }
            }
          `}
        </style>
        <div id="page-wrapper" className="InstagramHelpCenter-pageWapper" style={{ width: '100%', minWidth: 0 }}>
          <div className="InstagramHelpCenter-frameBox" style={{ width: '100%', minWidth: 0, background: '#fff', overflow: 'hidden' }}>
            <iframe
              ref={this.iframeRef}
              title="로보엠디 사용자 가이드"
              src={guideUrl}
              style={{ width: '100%', height: this.state.frameHeight + 'px', border: 0, display: 'block' }}
              loading="eager"
            />
          </div>
        </div>
      </>
    );
  }
}

export default InstagramHelpCenter;
